import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Folder, Document } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  updateDocument(request: Boundaries["updateDocument"]["request"]): void;
}

function useUpdateDocument(document: Identifiable<Document>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isUpdateDocumentRequestPending(document),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isUpdateDocumentRequestSuccess(document),
    ),
    isRequestFailure: useSelector(() =>
      selector.isUpdateDocumentRequestFailure(document),
    ),
    updateDocument: core.updateDocument,
  };
}

export { useUpdateDocument };
